// import "@mui/lab/themeAugmentation";
// @ts-ignore
import type { } from "@mui/lab/themeAugmentation";
import { createTheme as createMuiTheme } from "@mui/material/styles";
import type { VariantType } from "./configs/variants";

// Augment MUI Theme to include custom header/footer/sidebar properties
declare module "@mui/material/styles" {
  interface Theme {
    footer: VariantType["footer"];
    header: VariantType["header"];
    sidebar: VariantType["sidebar"];
  }
  interface ThemeOptions {
    footer?: VariantType["footer"];
    header?: VariantType["header"];
    sidebar?: VariantType["sidebar"];
  }
}

// Augment styled-components DefaultTheme so styled() components see the custom props
declare module "styled-components" {
  export interface DefaultTheme {
    footer: VariantType["footer"];
    header: VariantType["header"];
    sidebar: VariantType["sidebar"];
  }
}

import variants from "./configs/variants";
import typography from "./configs/typography";
import breakpoints from "./configs/breakpoints";
import components from "./configs/components";
import shadows from "./configs/shadows";

export const createThemeMaterialApp = (name: string) => {
  let themeConfig = variants.find((variant) => variant.name === name);

  if (!themeConfig) {
    console.warn(new Error(`The theme ${name} is not valid`));
    themeConfig = variants[0];
  }

  return createMuiTheme(
    {
      spacing: 4,
      breakpoints,
      // @ts-ignore
      components,
      typography,
      shadows,
      palette: themeConfig.palette,
      name: themeConfig.name,
      header: themeConfig.header,
      footer: themeConfig.footer,
      sidebar: themeConfig.sidebar,
    },
    {
      name: themeConfig.name,
      header: themeConfig.header,
      footer: themeConfig.footer,
      sidebar: themeConfig.sidebar,
    }
  );
};
